import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchLocationDetails } from "../APIServices/LocationDetails";
import { RootState } from "../store";
import { activateLoading, deactivateLoading } from "./GlobalSlice";
export interface LocationDetailsState {
  locationDetailsStoreData: any;
}

const initialState: LocationDetailsState = {
  locationDetailsStoreData: null,
};

//Reducers
export const LocationSlice = createSlice({
  name: "locationDetails",
  initialState,
  reducers: {
    clearLocationStorage: (state) => {
      state.locationDetailsStoreData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(searchLocationByQuery.fulfilled, (state, action) => {
      if (action?.payload) {
        state.locationDetailsStoreData = action?.payload?.searchLocationByQuery;
      }
    });
  },
});
//Selectors
export const locationDetailsData = (state: RootState) =>
  state.locationDetails.locationDetailsStoreData;
//Action
export const { clearLocationStorage } = LocationSlice.actions;
export const searchLocationByQuery = createAsyncThunk(
  "locationDetails/searchLocationByQuery",
  async (payload: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await fetchLocationDetails(payload?.data);
    if (response?.errors && response?.errors?.length > 0 && payload?.callback) {
      response?.errors?.forEach((err: any) => {
        payload?.callback(err?.message);
      });
      dispatch(deactivateLoading());
      return;
    }

    dispatch(deactivateLoading());
    return response?.data;
  }
);
export default LocationSlice.reducer;
